import LeadscoringPage from "./LeadscoringPage";
import MetalsPage from "./MetalsPage";
import AgriculturePage from "./AgriculturePage";
import MiningPage from "./MiningPage";
import RealtyPage from "./RealtyPage";
import AiServicesPage from "./AiServicesPage";
import PrecastPage from "./PrecastPage";

/** Map slug → page component for routing and subdomain builds. */
export const subdomainPages = {
  leadscoring: LeadscoringPage,
  metals: MetalsPage,
  agriculture: AgriculturePage,
  mining: MiningPage,
  realty: RealtyPage,
  aiservices: AiServicesPage,
  precast: PrecastPage,
};

export function getSubdomainPage(slug) {
  return subdomainPages[slug] ?? null;
}

export {
  LeadscoringPage,
  MetalsPage,
  AgriculturePage,
  MiningPage,
  RealtyPage,
  AiServicesPage,
  PrecastPage,
};
